/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import { Button } from '@thd-olt-component-react/button';
import { Col } from '@thd-olt-component-react/grid';
import classNames from 'classnames';
import '../../styles/refinement.scss';

const PriceRangeRefinement = (props) => {
  const [lowerBound, setLowerBound] = useState('');
  const [upperBound, setUpperBound] = useState('');
  const [lowerBoundFocused, setLowerBoundFocused] = useState(false);
  const [upperBoundFocused, setUpperBoundFocused] = useState(false);

  const { onChange, dimension, drawer } = props;

  const clearInputFields = () => {
    setLowerBound('');
    setUpperBound('');
  };

  const isDisabled = () => {
    return !(lowerBound.length || upperBound.length) || upperBound === '0';
  };

  const handleClick = useCallback((event) => {
    event.preventDefault();
    if (!isDisabled()) {
      onChange({
        refinement: {
          lowerbound: lowerBound,
          upperbound: upperBound,
          label: `$${lowerBound} - $${upperBound}`,
          deselectUrl: '?'
        },
        dimension: {
          dimensionId: 'custom_price',
          label: 'Price'
        }
      });

      setLowerBoundFocused(false);
      setUpperBoundFocused(false);
      clearInputFields();
    }
  },
  [lowerBound, upperBound]);

  const handleOnFocusFirstInput = useCallback((event) => {
    event.preventDefault();
    setLowerBoundFocused(true);
    setUpperBoundFocused(false);
  }, []);

  const handleOnFocusSecondInput = useCallback((event) => {
    event.preventDefault();
    setLowerBoundFocused(false);
    setUpperBoundFocused(true);
  }, []);

  const handleOnBlur = useCallback((event) => {
    event.preventDefault();

    setLowerBoundFocused(false);
    setUpperBoundFocused(false);
  }, []);

  const handleLowerBoundDropdownClick = useCallback((event) => {
    event.preventDefault();
    setLowerBound(event.target.innerHTML.substring(1));
    handleOnFocusSecondInput(event);
  }, []);

  const handleUpperBoundDropdownClick = useCallback((event) => {
    setUpperBound(event.target.innerHTML.substring(1));
    handleOnBlur(event);
  }, []);

  const refinementLabel = (refinement) => {
    return (refinement.label || '');
  };

  const lowerBoundPrices = dimension.refinements
    .filter((refinement) => refinementLabel(refinement).toUpperCase().indexOf('-') !== -1)
    .map((refinement, index) => (
      <li
        key={index}
        id="lowerBound"
        onMouseDown={handleLowerBoundDropdownClick}
        className="price-range__list"
      >
        {refinementLabel(refinement).substring(0, refinementLabel(refinement).indexOf(' '))}
      </li>
    ));

  const upperBoundPrices = dimension.refinements
    .filter((refinement) => refinementLabel(refinement).toUpperCase().indexOf('-') !== -1)
    .map((refinement, index) => (
      <li
        key={index}
        id="upperBound"
        onMouseDown={handleUpperBoundDropdownClick}
        className="price-range__list"
      >
        {refinementLabel(refinement).substring(refinementLabel(refinement).indexOf('-') + 2)}
      </li>
    ));

  const priceInputClassName = classNames('price-range__input', {
    'price-range__input--medium': drawer
  });

  const priceApplyBtnClassName = classNames('bttn-outline bttn-outline--dark price-range__bttn', {
    'price-range__bttn--medium': drawer
  });

  const lowerBoundContainer = classNames({ 'price-range__form--lower-bound': drawer });
  const upperBoundContainer = classNames({ 'price-range__form--upper-bound': drawer });
  return (
    <Col className="refinement price-range">
      <form>
        <div className="price-range__form">
          <div className={lowerBoundContainer}>
            <input
              autoComplete="off"
              className={priceInputClassName}
              placeholder="$ Min"
              name="lowerBound"
              value={lowerBound}
              maxLength="5"
              onChange={(event) => setLowerBound((event.target.value || '').replace(/\D/, ''))}
              onFocus={handleOnFocusFirstInput}
              onBlur={handleOnBlur}
              type="tel"
            />
            {lowerBoundFocused ? (
              <div className="price-range__container">
                <ul>{lowerBoundPrices}</ul>
              </div>
            ) : null}
          </div>
          <span>to</span>
          <div className={upperBoundContainer}>
            <input
              autoComplete="off"
              className={priceInputClassName}
              placeholder="$ Max"
              name="upperBound"
              value={upperBound}
              maxLength="5"
              onChange={(event) => setUpperBound((event.target.value || '').replace(/\D/, ''))}
              onFocus={handleOnFocusSecondInput}
              onBlur={handleOnBlur}
              type="tel"
            />
            {upperBoundFocused ? (
              <div className="price-range__container--upper-bound">
                <ul>{upperBoundPrices}</ul>
              </div>
            ) : null}
          </div>
          <Button
            dark={!isDisabled()}
            disabled={isDisabled()}
            inline
            outline
            onClick={handleClick}
          >
            {drawer ? 'Apply' : 'Go'}
          </Button>
        </div>
      </form>
    </Col>
  );
};

PriceRangeRefinement.propTypes = {
  dimension: PropTypes.shape({
    refinements: PropTypes.arrayOf(
      PropTypes.shape({})
    ),
  }),
  drawer: PropTypes.bool,
  onChange: PropTypes.func.isRequired
};

PriceRangeRefinement.defaultProps = {
  dimension: null,
  drawer: false,
};

PriceRangeRefinement.displayName = 'PriceRangeRefinement';

export { PriceRangeRefinement };